import {Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {
    IonIcon,
    IonRow,
    IonText,
    AnimationController
} from '@ionic/angular/standalone';
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from '@angular/material/card';

@Component({
    selector: 'app-dashboard-counter',
    templateUrl: './dashboard-counter.component.html',
    styleUrls: ['./dashboard-counter.component.css'],
    standalone: true,
    imports: [
        MatCard,
        MatCardHeader,
        MatCardTitle,
        IonIcon,
        MatCardContent,
        IonText,
        IonRow,
    ]
})
export class DashboardCounterComponent {
    @Input({required: true}) name: string = '';
    @Input() icon: string = '';
    @Input() iconColor: string = '';
    @Input() count: number = 0;
}
